import {XauditModel} from '../xaudit.model';

export class CfgAutoCheckOutModel extends XauditModel {
  TaskCfgID: string;
  LOCID: number;
  TaskOrder: string;
  enumAutoCheckOutTasksID: string;
}
